import React, { useEffect } from 'react';
import { Table, Row, Col } from 'antd';
import isEmpty from 'lodash/isEmpty';
import orderBy from 'lodash/orderBy';
import { connect } from 'react-redux';
import { fetchAnalysisLevelGuide } from 'appRedux/actions/AnalysisLevelGuide';
import Widget from 'components/Widget';
import AnalysisLevelGuideColumns from './AnalysisLevelGuideColumns';
import convertData from 'firebase/utils/convertData';

const AnalysisLevelGuide = ({
  analysisLevelGuideList,
  loading,
  fetchAnalysisLevelGuide,
}) => {
  const data = isEmpty(analysisLevelGuideList) ? [] : convertData(analysisLevelGuideList);
  const sortedData = isEmpty(data) ? [] : orderBy(data, 'report_metric');

  useEffect(() => {
    fetchAnalysisLevelGuide();
  }, [fetchAnalysisLevelGuide]);

  return (
    <>
      <Row>
        <Col span={24}>
          <Widget
            styleName="gx-order-history"
            title={<h2 className="h4 gx-text-capitalize gx-mb-0">Analysis level guide</h2>}
          >
            <Table
              loading={loading}
              pagination={false}
              bordered
              size='small'
              dataSource={sortedData}
              columns={AnalysisLevelGuideColumns()}
            />
          </Widget>
        </Col>
      </Row>
    </>
  );
}

const mapStateToProps = ({ analysisLevelGuide }) => {
  const { data: analysisLevelGuideList, loading } = analysisLevelGuide;
  return { analysisLevelGuideList, loading };
};

export default connect(
  mapStateToProps,
  {
    fetchAnalysisLevelGuide
  },
)(AnalysisLevelGuide);
